import { PRODUCTS } from "./store";

const FIRST = ["Anna", "Mārtiņš", "Ilze", "Jānis", "Laura", "Edgars", "Kristīne", "Raimonds", "Elīna", "Toms"];
const LAST = ["Kalniņa", "Liepiņš", "Ozola", "Bērziņš", "Krūmiņa", "Zariņš", "Priede", "Vītols", "Roze", "Eglītis"];
const COMPANIES = ["CleanPro SIA", "Hotel Demo Group", "OfficeHub SIA", "FoodServ Latvia", "IndustPark SIA", null, "EduServiss", null, "Demo Birojs SIA", null];
export const STATUSES = ["Jauns", "Apmaksāts", "Nosūtīts", "Izpildīts", "Atcelts"];

export const CUSTOMERS = FIRST.map((f, i) => ({
  id: i + 1,
  name: `${f} ${LAST[i]}`,
  company: COMPANIES[i],
  email: `${f.toLowerCase()}.demo@ecommercedemo.lv`,
  phone: `+371 20 000 ${String(100 + i * 7).padStart(3, "0")}`,
  type: COMPANIES[i] ? "B2B" : "B2C",
  orders: ((i * 5) % 14) + 1,
  spent: Math.round((((i * 137) % 900) + 120) * 100) / 100,
}));

export const MOCK_ORDERS = Array.from({ length: 18 }, (_, i) => {
  const c = CUSTOMERS[i % CUSTOMERS.length];
  const nItems = (i % 3) + 1;
  const items = Array.from({ length: nItems }, (_, j) => {
    const p = PRODUCTS[(i * 7 + j * 11) % PRODUCTS.length];
    return { name: p.name, sku: p.sku, qty: ((i + j) % 5) + 1, price: p.price };
  });
  const total = Math.round(items.reduce((s, it) => s + it.price * it.qty, 0) * 100) / 100;
  const d = new Date();
  d.setDate(d.getDate() - i - 1);
  return {
    nr: `DEMO-${100100 + i * 137}`,
    date: d.toISOString(),
    customer: c.name,
    email: c.email,
    company: c.company,
    delivery: ["kurjers", "pakomats", "veikals"][i % 3],
    payment: ["banka", "karte", "rekins"][i % 3],
    status: STATUSES[i % 4 === 0 ? 0 : (i % 5)],
    items,
    total,
  };
});

export const REVENUE_14D = Array.from({ length: 14 }, (_, i) => {
  const d = new Date();
  d.setDate(d.getDate() - (13 - i));
  return {
    date: `${d.getDate()}.${String(d.getMonth() + 1).padStart(2, "0")}.`,
    revenue: Math.round((300 + ((i * 173) % 450) + i * 25) * 100) / 100,
    orders: ((i * 3) % 9) + 2,
  };
});

export const loadOrders = () => {
  let local = [];
  try { local = JSON.parse(localStorage.getItem("demo_orders")) || []; } catch { /* noop */ }
  return [...local, ...MOCK_ORDERS];
};

const daysAgo = (n) => { const d = new Date(); d.setDate(d.getDate() - n); return d.toISOString(); };

export const RETURNS = [
  { id: "RMA-2041", order: "DEMO-100374", customer: "Ilze Ozola", product: "Mopa komplekts ar spaini 10 L", reason: "Bojāts transportēšanā", date: daysAgo(2), status: "Gaida lēmumu", refund: 14.9 },
  { id: "RMA-2040", order: "DEMO-100511", customer: "Jānis Bērziņš", product: "Darba cimdi neilona ar PU pārklājumu", reason: "Nepareizs izmērs", date: daysAgo(4), status: "Apstiprināts", refund: 8.9 },
  { id: "RMA-2039", order: "DEMO-100785", customer: "Edgars Zariņš", product: "Uzglabāšanas kaste ar vāku 30 L", reason: "Neatbilst aprakstam", date: daysAgo(6), status: "Gaida lēmumu", refund: 8.99 },
  { id: "RMA-2038", order: "DEMO-101196", customer: "Elīna Roze", product: "Stiklu tīrītājs ar smidzinātāju 750 ml", reason: "Pārdomāja pirkumu", date: daysAgo(9), status: "Noraidīts", refund: 2.79 },
  { id: "RMA-2037", order: "DEMO-101470", customer: "Anna Kalniņa", product: "Papīra dvieļi 2 slāņi, 150 loksnes", reason: "Bojāts iepakojums", date: daysAgo(12), status: "Atmaksāts", refund: 47.76 },
];

export const ABANDONED = [
  { id: 1, email: "guna.demo@ecommercedemo.lv", items: 4, value: 68.4, date: daysAgo(0), reminded: false },
  { id: 2, email: "peteris.demo@ecommercedemo.lv", items: 2, value: 23.8, date: daysAgo(1), reminded: true },
  { id: 3, email: "iepirkumi@cleanpro-demo.lv", items: 12, value: 412.6, date: daysAgo(1), reminded: false },
  { id: 4, email: "office@hoteldemo.lv", items: 6, value: 156.2, date: daysAgo(2), reminded: true },
  { id: 5, email: "sandra.demo@ecommercedemo.lv", items: 1, value: 8.99, date: daysAgo(3), reminded: false },
  { id: 6, email: "noliktava@industpark-demo.lv", items: 9, value: 287.5, date: daysAgo(4), reminded: false },
];

export const REVIEWS = [
  { id: 1, product: "Universālais tīrīšanas līdzeklis 1 L", author: "Anna K.", rating: 5, text: "Lieliska cena un kvalitāte, izmantojam birojā katru dienu.", date: daysAgo(1), status: "Gaida" },
  { id: 2, product: "Mikrošķiedras lupata, 5 gab.", author: "Mārtiņš L.", rating: 4, text: "Labas lupatas, kalpo ilgi. Iesaku.", date: daysAgo(2), status: "Apstiprināta" },
  { id: 3, product: "Darba cimdi neilona ar PU pārklājumu", author: "Edgars Z.", rating: 5, text: "Ērti un izturīgi, pasūtām regulāri ražotnei.", date: daysAgo(3), status: "Apstiprināta" },
  { id: 4, product: "Atkritumu maisi 60 L, 20 gab.", author: "Anonīms", rating: 1, text: "spams spams pērciet šeit lētāk www...", date: daysAgo(3), status: "Gaida" },
  { id: 5, product: "Papīra dvieļi 2 slāņi, 150 loksnes", author: "Ilze O.", rating: 4, text: "Laba uzsūktspēja, cena atbilstoša.", date: daysAgo(5), status: "Apstiprināta" },
  { id: 6, product: "Grīdas mazgāšanas līdzeklis 5 L", author: "Kristīne P.", rating: 5, text: "Profesionāla kvalitāte, pietiek ilgam laikam.", date: daysAgo(6), status: "Gaida" },
  { id: 7, product: "Vienreizējās glāzes plastmasas 200 ml", author: "Toms E.", rating: 3, text: "Normālas, bet plānas sieniņas.", date: daysAgo(8), status: "Apstiprināta" },
  { id: 8, product: "Kašpo puķu pods plastmasas Ø14 cm", author: "Laura K.", rating: 5, text: "Skaisti podi, laba krāsu izvēle.", date: daysAgo(10), status: "Apstiprināta" },
];

export const SUPPLIERS = [
  { id: 1, name: "Demo Chem Baltic SIA", contact: "Andris Demo", email: "orders@demochembaltic.lv", products: 14, leadTime: "3 dienas", debt: 1240.5 },
  { id: 2, name: "PaperPro Demo UAB", contact: "Jolanta Demo", email: "sales@paperpro-demo.lt", products: 8, leadTime: "5 dienas", debt: 0 },
  { id: 3, name: "PlastFab Demo OÜ", contact: "Marten Demo", email: "info@plastfab-demo.ee", products: 12, leadTime: "7 dienas", debt: 860.0 },
  { id: 4, name: "SafetyFirst Demo GmbH", contact: "Hans Demo", email: "export@safetyfirst-demo.de", products: 6, leadTime: "10 dienas", debt: 0 },
  { id: 5, name: "HygienePlus Demo Sp. z o.o.", contact: "Kasia Demo", email: "b2b@hygieneplus-demo.pl", products: 8, leadTime: "6 dienas", debt: 322.4 },
];

export const CUSTOMER_GROUPS = [
  { id: 1, name: "B2C — privātpersonas", discount: 0, members: 6, priceDisplay: "ar PVN" },
  { id: 2, name: "B2B Standarta", discount: 8, members: 3, priceDisplay: "bez PVN" },
  { id: 3, name: "B2B Zelta", discount: 15, members: 2, priceDisplay: "bez PVN" },
  { id: 4, name: "VIP / Līgumklienti", discount: 22, members: 1, priceDisplay: "bez PVN" },
];

export const TICKETS = [
  { id: "T-1024", subject: "Kur ir mans pasūtījums DEMO-100374?", customer: "Ilze Ozola", priority: "Augsta", status: "Atvērts", date: daysAgo(0) },
  { id: "T-1023", subject: "Vēlos saņemt rēķinu ar PVN atšifrējumu", customer: "Hotel Demo Group", priority: "Vidēja", status: "Atbildēts", date: daysAgo(1) },
  { id: "T-1022", subject: "Vai pieejama piegāde sestdienā?", customer: "Laura Krūmiņa", priority: "Zema", status: "Atvērts", date: daysAgo(1) },
  { id: "T-1021", subject: "Bojāta prece sūtījumā", customer: "Jānis Bērziņš", priority: "Augsta", status: "Procesā", date: daysAgo(2) },
  { id: "T-1020", subject: "B2B konta pieteikums", customer: "FoodServ Latvia", priority: "Vidēja", status: "Aizvērts", date: daysAgo(4) },
  { id: "T-1019", subject: "Preces atgriešanas nosacījumi", customer: "Elīna Roze", priority: "Zema", status: "Aizvērts", date: daysAgo(6) },
];

export const CAMPAIGNS = [
  { id: 1, name: "Vasaras izpārdošana –25%", status: "Aktīva", sent: 2450, opened: 41, clicked: 12, revenue: 1840.5, date: daysAgo(3) },
  { id: 2, name: "B2B jaunumu apskats — jūnijs", status: "Nosūtīta", sent: 380, opened: 58, clicked: 22, revenue: 960.0, date: daysAgo(8) },
  { id: 3, name: "Pamesto grozu atgādinājums", status: "Automātiska", sent: 156, opened: 47, clicked: 19, revenue: 420.3, date: daysAgo(1) },
  { id: 4, name: "Jauno klientu sveiciens –10%", status: "Automātiska", sent: 89, opened: 62, clicked: 31, revenue: 310.8, date: daysAgo(1) },
  { id: 5, name: "Pavasara katalogs 2026", status: "Melnraksts", sent: 0, opened: 0, clicked: 0, revenue: 0, date: daysAgo(0) },
];

export const BANNERS_ADMIN = [
  { id: 1, name: "Enterprise hero — centralizēts iepirkums", position: "Sākumlapa / Hero", active: true, clicks: 342 },
  { id: 2, name: "Vasaras kampaņa –25% + countdown", position: "Sākumlapa / Hero", active: true, clicks: 891 },
  { id: 3, name: "Akciju sānu baneris", position: "Sākumlapa / Sānu", active: true, clicks: 156 },
  { id: 4, name: "Ziemassvētku kampaņa 2025", position: "Sākumlapa / Hero", active: false, clicks: 2140 },
];

export const CMS_PAGES = [
  { id: 1, title: "Par mums", slug: "/par-mums", status: "Publicēta", updated: daysAgo(5) },
  { id: 2, title: "Piegādes noteikumi", slug: "/piegade", status: "Publicēta", updated: daysAgo(12) },
  { id: 3, title: "Atgriešanas politika", slug: "/atgriesana", status: "Publicēta", updated: daysAgo(12) },
  { id: 4, title: "Privātuma politika", slug: "/privatums", status: "Publicēta", updated: daysAgo(30) },
  { id: 5, title: "Lietošanas noteikumi", slug: "/noteikumi", status: "Publicēta", updated: daysAgo(30) },
  { id: 6, title: "BUJ — biežāk uzdotie jautājumi", slug: "/buj", status: "Melnraksts", updated: daysAgo(1) },
];

export const MODULES = [
  { id: 1, name: "Google Analytics 4", cat: "Analītika", desc: "Apmeklējumu un konversiju izsekošana", installed: true, enabled: true },
  { id: 2, name: "Meta Pixel", cat: "Analītika", desc: "Facebook/Instagram reklāmu izsekošana", installed: true, enabled: true },
  { id: 3, name: "SEO Pro", cat: "SEO", desc: "Meta tagi, sitemap, hreflang, strukturētie dati", installed: true, enabled: true },
  { id: 4, name: "Live Chat + WhatsApp", cat: "Komunikācija", desc: "Tiešsaistes čats ar klientiem", installed: true, enabled: false },
  { id: 5, name: "Mailchimp sinhronizācija", cat: "Mārketings", desc: "Abonentu un kampaņu sinhronizācija", installed: true, enabled: true },
  { id: 6, name: "PDF rēķini un pavadzīmes", cat: "Dokumenti", desc: "Automātiska PDF ģenerēšana pasūtījumiem", installed: true, enabled: true },
  { id: 7, name: "Omniva pakomāti", cat: "Piegāde", desc: "Pakomātu saraksts un manifestu druka", installed: true, enabled: true },
  { id: 8, name: "DPD kurjers", cat: "Piegāde", desc: "DPD etiķetes un sekošana", installed: true, enabled: true },
  { id: 9, name: "Stripe maksājumi", cat: "Maksājumi", desc: "Kartes, Apple Pay, Google Pay", installed: true, enabled: false },
  { id: 10, name: "PayPal Checkout", cat: "Maksājumi", desc: "PayPal maksājumu pieņemšana", installed: false, enabled: false },
  { id: 11, name: "Lojalitātes punkti", cat: "Mārketings", desc: "Punktu uzkrāšana un apmaiņa pret atlaidēm", installed: false, enabled: false },
  { id: 12, name: "Dāvanu kartes", cat: "Mārketings", desc: "Elektronisko dāvanu karšu pārdošana", installed: false, enabled: false },
  { id: 13, name: "Produktu CSV imports", cat: "Katalogs", desc: "Masveida produktu imports/eksports", installed: true, enabled: true },
  { id: 14, name: "XML cenu lapas / Feed", cat: "Katalogs", desc: "Salīdzināšanas portālu plūsmas (kurpirkt, GMC)", installed: true, enabled: true },
  { id: 15, name: "Multivaloda LV/EN/RU", cat: "Lokalizācija", desc: "Satura tulkojumu pārvaldība", installed: false, enabled: false },
  { id: 16, name: "Automātiskās dublējumkopijas", cat: "Sistēma", desc: "Ikdienas datu bāzes backup", installed: true, enabled: true },
];

export const ADMIN_USERS = [
  { id: 1, name: "Demo Administrators", email: "admin@ecommercedemo.lv", role: "Superadministrators", lastLogin: daysAgo(0), active: true },
  { id: 2, name: "Anna Menedžere", email: "menedzeris@ecommercedemo.lv", role: "Pārdošanas menedžeris", lastLogin: daysAgo(0), active: true },
  { id: 3, name: "Jānis Noliktavnieks", email: "noliktava@ecommercedemo.lv", role: "Noliktavas darbinieks", lastLogin: daysAgo(1), active: true },
  { id: 4, name: "Ilze Grāmatvede", email: "gramatvediba@ecommercedemo.lv", role: "Grāmatvedis (tikai lasīšana)", lastLogin: daysAgo(3), active: false },
];

export const ROLES = ["Superadministrators", "Pārdošanas menedžeris", "Noliktavas darbinieks", "Grāmatvedis (tikai lasīšana)", "Satura redaktors"];

export const ACTIVITY_LOG = [
  { id: 1, user: "admin@ecommercedemo.lv", action: "Mainīja pasūtījuma DEMO-100237 statusu uz 'Apmaksāts'", date: daysAgo(0) },
  { id: 2, user: "menedzeris@ecommercedemo.lv", action: "Izveidoja atlaides kodu VASARA25", date: daysAgo(0) },
  { id: 3, user: "noliktava@ecommercedemo.lv", action: "Atjaunoja krājumus precei DEMO-0010 (+200 gab.)", date: daysAgo(1) },
  { id: 4, user: "admin@ecommercedemo.lv", action: "Apstiprināja atsauksmi #2", date: daysAgo(1) },
  { id: 5, user: "menedzeris@ecommercedemo.lv", action: "Nosūtīja kampaņu 'B2B jaunumu apskats'", date: daysAgo(2) },
  { id: 6, user: "admin@ecommercedemo.lv", action: "Rediģēja produktu 'Universālais tīrīšanas līdzeklis 1 L'", date: daysAgo(2) },
  { id: 7, user: "admin@ecommercedemo.lv", action: "Aktivizēja moduli 'Omniva pakomāti'", date: daysAgo(3) },
  { id: 8, user: "noliktava@ecommercedemo.lv", action: "Izveidoja sūtījumu pasūtījumam DEMO-100511", date: daysAgo(3) },
  { id: 9, user: "admin@ecommercedemo.lv", action: "Pievienoja jaunu administratoru 'Ilze Grāmatvede'", date: daysAgo(4) },
  { id: 10, user: "menedzeris@ecommercedemo.lv", action: "Apstiprināja RMA-2040 atgriešanu", date: daysAgo(4) },
];

export const ATTRIBUTES = [
  { id: 1, name: "Krāsa", type: "Krāsu izvēle", values: ["Balta", "Melna", "Zila", "Sarkana", "Zaļa", "Caurspīdīga", "Terakota"] },
  { id: 2, name: "Izmērs", type: "Saraksts", values: ["S", "M", "L", "XL", "8", "9", "10"] },
  { id: 3, name: "Tilpums", type: "Saraksts", values: ["200 ml", "500 ml", "750 ml", "1 L", "5 L", "10 L", "30 L"] },
  { id: 4, name: "Materiāls", type: "Saraksts", values: ["PP plastmasa", "LDPE", "HDPE", "Mikrošķiedra", "Papīrs", "Bērza koks"] },
  { id: 5, name: "Iepakojuma daudzums", type: "Skaitlis", values: ["1", "5", "10", "12", "20", "24", "50", "100"] },
];

export const SALES_BY_CATEGORY = [
  { name: "Tīrīšanas līdzekļi", value: 2840 },
  { name: "Higiēnas preces", value: 2210 },
  { name: "Uzkopšanas inventārs", value: 1680 },
  { name: "Vienreizlietojamie trauki", value: 1240 },
  { name: "Plastmasas izstrādājumi", value: 820 },
  { name: "Rūpniecības preces", value: 610 },
  { name: "Pārējās", value: 218 },
];
